module.exports = __webpack_public_path__ + "img/remake.d95525ce.svg";